// PDA — Favoris. Liés au COMPTE (aucun favori invité, décision Sam 22/07).
// Lecture : état SSR posé par pda-wishlist-data.liquid.
// Écriture : App Proxy /apps/pda/wishlist (le seul chemin possible depuis un
// thème Liquid — cf. PLAN-Favoris.md).
const NOEUD_ETAT = document.getElementById('pda-wishlist-state');
const ETAT = (() => {
  try {
    return JSON.parse(NOEUD_ETAT?.textContent ?? '{}');
  } catch {
    return {};
  }
})();

const CONNECTE = ETAT.connecte === true;
const LOGIN_URL = ETAT.loginUrl || '/account/login';
// Clé de l'intention mémorisée avant un départ vers le login (cf. Task 6/7).
const CLE_INTENTION = 'pda:wishlist:intention';

let entrees = Array.isArray(ETAT.entrees) ? ETAT.entrees : [];
const idsFavoris = new Set(entrees.map((e) => Number(e.id)));
const idsEnCours = new Set();

function estFavori(id) {
  return idsFavoris.has(Number(id));
}

/** Peint UN bouton selon l'état courant. */
function peindre(bouton) {
  const id = Number(bouton.dataset.productId);
  const actif = estFavori(id);
  const presse = actif ? 'true' : 'false';
  if (bouton.getAttribute('aria-pressed') !== presse) bouton.setAttribute('aria-pressed', presse);
  bouton.classList.toggle('is-favori', actif);
  bouton.disabled = idsEnCours.has(id);
  /* LOT 2b (25/08) : clés js:true du dictionnaire — PDA.t peint la clé et
   * console.error si le dictionnaire manque (échec FORT, jamais silencieux). */
  const titre = window.PDA && PDA.t ? (actif ? PDA.t('pda.favoris.retirer') : PDA.t('pda.favoris.ajouter')) : (actif ? 'Retirer des favoris' : 'Ajouter aux favoris');
  bouton.setAttribute('title', titre);
  if (bouton.hasAttribute('data-pda-cart-fav')) bouton.setAttribute('aria-label', titre);
}

/** Re-peint TOUS les boutons présents. Appelé au boot ET après chaque rendu de
 *  grille : une card injectée porte un cœur neuf, à false. */
function hydrater(racine = document) {
  racine.querySelectorAll('[data-pda-wishlist-toggle]').forEach(peindre);
}

function diffuser() {
  document.dispatchEvent(new CustomEvent('pda:wishlist-change', { detail: { entrees } }));
}

async function basculer(bouton) {
  const id = Number(bouton.dataset.productId);
  const h = bouton.dataset.productHandle;
  if (!Number.isFinite(id) || !h || idsEnCours.has(id)) return;

  idsEnCours.add(id);
  const etaitFavori = estFavori(id);
  // Optimiste : on peint AVANT le réseau (le geste doit répondre au doigt), on
  // ROLLBACK si le serveur refuse.
  if (etaitFavori) idsFavoris.delete(id);
  else idsFavoris.add(id);
  hydrater();

  try {
    const reponse = await fetch('/apps/pda/wishlist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: etaitFavori ? 'retirer' : 'ajouter', id, h }),
    });
    const corps = await reponse.json();
    if (!reponse.ok || !corps.ok) throw new Error(corps.raison || `HTTP ${reponse.status}`);

    entrees = corps.liste;
    idsFavoris.clear();
    entrees.forEach((e) => idsFavoris.add(Number(e.id)));
    diffuser();
  } catch (erreur) {
    // Rollback : l'état affiché doit toujours refléter le SERVEUR, jamais un
    // succès supposé.
    if (etaitFavori) idsFavoris.add(id);
    else idsFavoris.delete(id);
    console.warn('[pda-wishlist] échec, état restauré :', erreur);
  } finally {
    idsEnCours.delete(id);
    hydrater();
  }
}

// Délégation : les cards du moteur sont injectées après coup, un écouteur par
// bouton en manquerait la moitié.
document.addEventListener('click', (evenement) => {
  const bouton = evenement.target.closest('[data-pda-wishlist-toggle]');
  if (!bouton) return;
  evenement.preventDefault();

  if (!CONNECTE) {
    // Mémoriser l'intention AVANT de partir : au retour, le geste aboutit.
    sessionStorage.setItem(
      CLE_INTENTION,
      JSON.stringify({ id: Number(bouton.dataset.productId), h: bouton.dataset.productHandle, url: location.pathname + location.search })
    );
    document.dispatchEvent(new CustomEvent('pda:wishlist-login-requis'));
    return;
  }
  basculer(bouton);
});

// `detail.carte` (posé par le lot LAZY de renderPage, une card à la fois via
// l'IntersectionObserver) borne la re-peinture à CETTE card — coût O(1), pas un
// balayage du document à chaque scroll. `detail.grille` (lot EAGER, jusqu'à 12
// cards d'un coup) borne au conteneur de la grille. Repli document si absent.
document.addEventListener('pda:grid-rendered', (evenement) => {
  const detail = evenement.detail || {};
  hydrater(detail.carte || detail.grille || document);
});

// Sur la page favoris, retirer une œuvre doit la faire DISPARAÎTRE de la grille
// (ailleurs, le cœur se vide simplement). Sans ça, l'œuvre retirée reste affichée
// jusqu'au prochain rechargement — et le compteur ment.
// La liste À JOUR voyage DANS l'événement : le moteur n'a ainsi rien à aller
// chercher dans un global, et le contrat reste explicite.
document.addEventListener('pda:wishlist-change', () => {
  if (!document.querySelector('[data-pda-wishlist-grid]')) return;
  document.dispatchEvent(new CustomEvent('pda:catalog-refresh', { detail: { entrees } }));
});

hydrater();

// Repeindre APRÈS le morph réel, y compris le chargement différé du drawer.
// cart:update peut arriver avant le rendu ; aucun MutationObserver ne réécrit
// les attributs pendant que le moteur de morph travaille.
document.addEventListener('pda:section-rendered', (evenement) => {
  const section = evenement.detail?.section;
  if (section) hydrater(section);
});

// ── Reprise de l'intention après connexion ───────────────────────────────────
// Le client a cliqué un cœur en étant déconnecté : on a mémorisé l'œuvre avant
// de l'envoyer au login. De retour CONNECTÉ, on rejoue le geste — sinon il
// aurait traversé tout un flow d'authentification pour rien.
async function rejouerIntention() {
  if (!CONNECTE) return;
  const brut = sessionStorage.getItem(CLE_INTENTION);
  if (!brut) return;
  // Consommer AVANT de tenter : une intention rejouée en boucle sur un échec
  // serveur harcèlerait le proxy à chaque chargement de page.
  sessionStorage.removeItem(CLE_INTENTION);

  let intention;
  try {
    intention = JSON.parse(brut);
  } catch {
    return;
  }
  if (!intention || !Number.isFinite(Number(intention.id)) || !intention.h) return;
  if (estFavori(Number(intention.id))) return; // déjà posé : rien à faire

  try {
    const reponse = await fetch('/apps/pda/wishlist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'ajouter', id: Number(intention.id), h: intention.h }),
    });
    const corps = await reponse.json();
    if (!reponse.ok || !corps.ok) throw new Error(corps.raison || `HTTP ${reponse.status}`);
    entrees = corps.liste;
    idsFavoris.clear();
    entrees.forEach((e) => idsFavoris.add(Number(e.id)));
    hydrater();
    diffuser();
  } catch (erreur) {
    console.warn('[pda-wishlist] reprise impossible :', erreur);
  }
}

rejouerIntention();

window.pdaWishlist = { estFavori, hydrater, entrees: () => entrees, CLE_INTENTION, LOGIN_URL, CONNECTE };

// ── Modale « connectez-vous » ────────────────────────────────────────────────
// Le module ne CONNAÎT pas la modale : il émet `pda:wishlist-login-requis` (cf.
// plus haut) et c'est ce bloc qui la relie. Si le snippet n'est pas rendu sur la
// page, on retombe sur une navigation directe vers le login — le geste du client
// aboutit quand même, il n'est jamais avalé en silence.
const modale = document.getElementById('pda-wishlist-modal');
document.addEventListener('pda:wishlist-login-requis', () => {
  if (modale && typeof modale.showModal === 'function') {
    if (!modale.open) modale.showModal();
  } else {
    window.location.assign(LOGIN_URL);
  }
});
modale?.addEventListener('click', (evenement) => {
  if (evenement.target.closest('[data-pda-wishlist-modal-fermer]')) modale.close();
});
